import { postDepartmentList, postMenuList, postRoleList } from '@/service/main/main'
import { defineStore } from 'pinia'

interface IMainState {
  roles: any[]
  departments: any[]
  menus: any[]
}
const useMainStore = defineStore('main', {
  state: (): IMainState => ({
    roles: [],
    departments: [],
    menus: []
  }),
  actions: {
    /* 获取整个角色、部门、菜单列表 */
    async getEntireDataListAction() {
      const roleRes = await postRoleList()
      const departmentRes = await postDepartmentList()
      const menuRes = await postMenuList()

      this.roles = roleRes.data.list
      this.departments = departmentRes.data.list
      this.menus = menuRes.data.list
    }
  }
})

export default useMainStore
